module.exports = {"id":"dp3_2l3q5","text":"Integrating and re-elaborating digital content","instructions":"What is an effective way to transform data to improve understanding?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.2","questionType":"PickOne","random":true,"options":[{"id":"dp3_2l3q5-a1","text":"Converting tables into appropriate charts","score":3.7},{"id":"dp3_2l3q5-a2","text":"Increasing file size without redesign","score":1.3},{"id":"dp3_2l3q5-a3","text":"Duplicating the same data layout","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.2/l3q5.json
// module id = 1139
// module chunks = 41